import { AnyAction } from 'redux';
import {
  REQUEST,
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  CLEAR_SPECIFIC_REQUEST,
  CLEAR_REQUEST,
} from './actionType';

// dispatches parameter action after dispatching REQUEST action
export const initiateRequest = ({ type, payload }: AnyAction) => ({
  type: REQUEST,
  payload: {
    type,
    payload,
  },
});

export const succeededRequest = (
  type: string,
  response: object | null = null,
) => ({
  type: REQUEST_SUCCESS,
  payload: {
    type,
    response,
  },
});

export const failedRequest = (
  type: string,
  error: Error | string,
) => ({
  type: REQUEST_FAILURE,
  payload: {
    type,
    error,
  },
});

export const clearSpecificRequest = (type: string) => ({
  type: CLEAR_SPECIFIC_REQUEST,
  payload: {
    type,
  },
});

export const clearRequest = () => ({ type: CLEAR_REQUEST });
